import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {MBranch} from '../model/m-branch';
import {AppSettings} from '../../../settings/app-settings';

@Injectable()
export class MBranchService {

  constructor(private http: HttpClient) {
  }

  public findAll(): Observable<MBranch[]> {
    return this.http.get<MBranch[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-branch/find-all');
  }

  public findByType(branchType: string): Observable<MBranch[]> {
    return this.http.get<MBranch[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-branch/find-type/' + branchType);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/service/m-branch/service/m-branch.service.ts